<template>
  <a-loading
    :loading="versionMeta.loading"
  >
    <version-form
      :version="{gameId: selectedGameId, ...version}"
      mode="edit"
      @submit="handleSubmit"
      @delete="handleDelete"
    />
  </a-loading>
</template>

<script>
  import VersionForm from '@/components/VersionForm'
  import { useDeleteVersion, useEditVersion, useVersion } from '@/views/games/gameHooks'
  import { ALoading } from 'codefabrik-gui-vue'
  import { mapState } from 'vuex'

  export default {
    name: 'EditVersion',
    components: { VersionForm, ALoading },
    mixins: [
      useVersion('version'),
      useEditVersion('handleSubmit'),
      useDeleteVersion('deleteVersion')
    ],
    methods: {
      handleDelete () {
        this.deleteVersion({ id: this.version.id })
      }
    },
    computed: {
      ...mapState('game', ['selectedGameId']),
    },
  }
</script>

<style scoped>

</style>
